'use client';

import AppImage from '@/components/ui/AppImage';

export default function FeaturedInSection() {
  const logos = [
  { id: 'logo_glamour', src: "/assets/images/23-1770581711871.png", alt: 'Glamour logo' },
  { id: 'logo_danafarber', src: "/assets/images/14-1770580970440.png", alt: 'Dana-Farber Cancer Institute and Harvard Medical School logos' },
  { id: 'logo_forbes', src: "/assets/images/24-1770581782309.png", alt: 'Forbes logo' },
  { id: 'logo_cornelldailysun', src: "/assets/images/22-1770581704102.png", alt: 'The Cornell Daily Sun logo' },
  { id: 'logo_girlswhocode', src: "/assets/images/13-1770580883477.png", alt: 'Girls Who Code logo' },
  { id: 'logo_new', src: "/assets/images/15-1770581074290.png", alt: 'Partner organization logo' },
  { id: 'logo_kodewithklossy', src: "/assets/images/17-1770581232452.png", alt: 'Kode with Klossy logo' },
  { id: 'logo_missamerica', src: "/assets/images/18-1770581322587.png", alt: 'Miss America logo' },
  { id: 'logo_nyt', src: "/assets/images/19-1770581375452.png", alt: 'The New York Times logo' },
  { id: 'logo_nasa', src: "/assets/images/16-1770581127236.png", alt: 'NASA logo' },
  { id: 'logo_trio', src: "/assets/images/20-1770581451847.png", alt: 'TRIO Ronald E. McNair Post-Baccalaureate Achievement Program logo' },
  { id: 'logo_stanford', src: "/assets/images/21-1770581516297.png", alt: 'Stanford University logo' }];


  return (
    <section className="py-20 px-6 bg-white overflow-hidden border-y border-border">
      <div className="max-w-7xl mx-auto">
        <p className="text-center font-bold uppercase tracking-wider mb-12 text-foreground/40 text-xs">
          As Seen In & Collaborations With
        </p>
        
        <div className="relative">
          <div className="flex animate-infinite-scroll hover:pause-animation">
            {/* First set of logos */}
            {logos?.map((logo) =>
            <div key={logo?.id} className="flex-shrink-0 mx-8 flex items-center justify-center transition-all duration-300">
                <AppImage
                src={logo?.src}
                alt={logo?.alt}
                className="h-56 w-auto object-contain" />
              </div>
            )}
            {/* Duplicate set for seamless loop */}
            {logos?.map((logo) =>
            <div key={`${logo?.id}-duplicate`} className="flex-shrink-0 mx-8 flex items-center justify-center transition-all duration-300">
                <AppImage
                src={logo?.src}
                alt={logo?.alt}
                className="h-56 w-auto object-contain" />
              </div>
            )}
          </div>
        </div>
      </div>
    </section>);

}